/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "BGN" | "CAD" | "CHF" | "CLP" | "CNH" | "CNY" | "CZK" | "DKK" | "EUR" | "GBP" | "HKD" | "HUF" | "ISK" | "JPY" | "MXN" | "NOK" | "NZD" | "PLN" | "ROL" | "RON" | "RUB" | "SEK" | "SGD" | "USD" | "ZAR" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type BankCashTransactionList_viewer$ref: FragmentReference;
declare export opaque type BankCashTransactionList_viewer$fragmentType: BankCashTransactionList_viewer$ref;
export type BankCashTransactionList_viewer = {|
  +bankCashTransactions: ?{|
    +count: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +processedAt: ?any,
        +processedBy: ?{|
          +username: string,
          +fullName: ?string,
        |},
        +group: ?{|
          +id: string,
          +description: ?string,
        |},
        +remitterReference: string,
        +notificationId: string,
        +eventId: string,
        +transactionReference: string,
        +otherPartyAccountName: string,
        +otherPartyAccountNumber: string,
        +otherPartySortCode: string,
        +transactionDate: any,
        +ignored: boolean,
        +currency: Currency,
        +reportDate: any,
        +amount: number,
        +notes: ?{|
          +id: string
        |},
        +brokeractivityPtr: {|
          +group: ?{|
            +id: string,
            +description: ?string,
          |},
          +brokeractivitytransactionSet: {|
            +edges: $ReadOnlyArray<?{|
              +node: ?{|
                +id: string,
                +account: {|
                  +id: string,
                  +name: ?string,
                |},
                +brokeractivitytransactioncontractdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +portfolio: {|
                        +id: string
                      |},
                      +contract: {|
                        +id: string,
                        +symbol: string,
                      |},
                      +quantity: number,
                    |}
                  |}>
                |},
                +brokeractivitytransactioncashdeltaSet: {|
                  +edges: $ReadOnlyArray<?{|
                    +node: ?{|
                      +currency: Currency,
                      +quantity: number,
                    |}
                  |}>
                |},
              |}
            |}>
          |},
          +id: string,
          +responsiblecontract: ?{|
            +id: string,
            +contract: {|
              +id: string,
              +name: ?string,
              +ibConId: any,
              +symbol: string,
              +currency: Currency,
              +exchange: {|
                +name: string,
                +symbol: string,
              |},
            |},
          |},
        |},
      |}
    |}>,
    +pageInfo: {|
      +endCursor: ?string,
      +startCursor: ?string,
      +hasNextPage: boolean,
      +hasPreviousPage: boolean,
    |},
  |},
  +$refType: BankCashTransactionList_viewer$ref,
|};
export type BankCashTransactionList_viewer$data = BankCashTransactionList_viewer;
export type BankCashTransactionList_viewer$key = {
  +$data?: BankCashTransactionList_viewer$data,
  +$fragmentRefs: BankCashTransactionList_viewer$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "group",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityGroupNode",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v3 = [
  (v0/*: any*/)
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "BankCashTransactionList_viewer",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "first",
      "type": "Int",
      "defaultValue": 10
    },
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "search",
      "type": "String",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "reportDate",
      "type": "Date",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "processedAt_Isnull",
      "type": "Boolean",
      "defaultValue": null
    },
    {
      "kind": "LocalArgument",
      "name": "ignored",
      "type": "Boolean",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "bankCashTransactions",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "ignored",
          "variableName": "ignored"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset"
        },
        {
          "kind": "Variable",
          "name": "processedAt_Isnull",
          "variableName": "processedAt_Isnull"
        },
        {
          "kind": "Variable",
          "name": "reportDate",
          "variableName": "reportDate"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "BankCashTransactionNodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "count",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "BankCashTransactionNodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "BankCashTransactionNode",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "processedAt",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "processedBy",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "UserNode",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "username",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "fullName",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "remitterReference",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "notificationId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "eventId",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "transactionReference",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "otherPartyAccountName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "otherPartyAccountNumber",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "otherPartySortCode",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "transactionDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "ignored",
                  "args": null,
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "reportDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "amount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "notes",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "NotesNode",
                  "plural": false,
                  "selections": (v3/*: any*/)
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "brokeractivityPtr",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "BrokerActivityNode",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "brokeractivitytransactionSet",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "BrokerActivityTransactionNodeConnection",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "edges",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "BrokerActivityTransactionNodeEdge",
                          "plural": true,
                          "selections": [
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "node",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "BrokerActivityTransactionNode",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "account",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "AccountNode",
                                  "plural": false,
                                  "selections": [
                                    (v0/*: any*/),
                                    (v4/*: any*/)
                                  ]
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "brokeractivitytransactioncontractdeltaSet",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "edges",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "name": "node",
                                          "storageKey": null,
                                          "args": null,
                                          "concreteType": "BrokerActivityTransactionContractDeltaNode",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "name": "portfolio",
                                              "storageKey": null,
                                              "args": null,
                                              "concreteType": "PortfolioNode",
                                              "plural": false,
                                              "selections": (v3/*: any*/)
                                            },
                                            {
                                              "kind": "LinkedField",
                                              "alias": null,
                                              "name": "contract",
                                              "storageKey": null,
                                              "args": null,
                                              "concreteType": "ContractNode",
                                              "plural": false,
                                              "selections": [
                                                (v0/*: any*/),
                                                (v5/*: any*/)
                                              ]
                                            },
                                            (v6/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                },
                                {
                                  "kind": "LinkedField",
                                  "alias": null,
                                  "name": "brokeractivitytransactioncashdeltaSet",
                                  "storageKey": null,
                                  "args": null,
                                  "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "LinkedField",
                                      "alias": null,
                                      "name": "edges",
                                      "storageKey": null,
                                      "args": null,
                                      "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "kind": "LinkedField",
                                          "alias": null,
                                          "name": "node",
                                          "storageKey": null,
                                          "args": null,
                                          "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                          "plural": false,
                                          "selections": [
                                            (v2/*: any*/),
                                            (v6/*: any*/)
                                          ]
                                        }
                                      ]
                                    }
                                  ]
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    (v0/*: any*/),
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "responsiblecontract",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ResponsibleContractNode",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "contract",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "ContractNode",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v4/*: any*/),
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "ibConId",
                              "args": null,
                              "storageKey": null
                            },
                            (v5/*: any*/),
                            (v2/*: any*/),
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "exchange",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "ExchangeNode",
                              "plural": false,
                              "selections": [
                                (v4/*: any*/),
                                (v5/*: any*/)
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "startCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasPreviousPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '2ee2601682173c70c125de01cef5ace3';
module.exports = node;
